import React from 'react';
import { Button } from 'antd';
import logoCPng from 'assets/images/logo-c.png';
import logoPng from 'assets/images/logo.png';
import { useGetOAuthToken } from 'services/auth/mutations';
import ProcessingTeamImpersonationBar, { useIsImpersonating } from 'components/Atoms/Bars/ProcessingTeamImpersonationBar/ProcessingTeamImpersonationBar';

const HeaderHome = () => {
  const { execute: getOAuthToken } = useGetOAuthToken();

  const onCreateNewLoan = () => {
    getOAuthToken({ })
      .then(({ data }) => {
        if (data) {
          const oAuthToken = data.getOAuthToken;
          window.open(`${process.env.REACT_APP_ONBOARDING_SITE_URL}/?oauth=${oAuthToken}`, '_blank');
        }
      })
  }

  const { showProcessingBar }  = useIsImpersonating();

  const componentClassName = showProcessingBar ? 'HeaderHome-space processing' : 'HeaderHome-space';
  return (
    <div className={componentClassName}>
      <div className="HeaderHome">
        {
          showProcessingBar &&
          <ProcessingTeamImpersonationBar />
        }
        <div className='content'>
          <div className="box">
            <a href='http://constlending.com/' target="_blank" rel="noopener noreferrer">
              <img className="logo-c" src={logoCPng} alt="logo-c" style={{ marginRight: 8 }} />
              <img className="logo" src={logoPng} alt="logo" />
            </a>
          </div>
          <Button className="button button-secondary" onClick={onCreateNewLoan}>New loan</Button>
        </div>
      </div>
    </div>
  );
};
export default HeaderHome;
